var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71875 16C4.71875 9.7868 9.75555 4.75 15.9688 4.75C22.182 4.75 27.2188 9.7868 27.2188 16C27.2188 22.2132 22.182 27.25 15.9688 27.25C9.75555 27.25 4.71875 22.2132 4.71875 16ZM15.9688 3.25C8.92712 3.25 3.21875 8.95837 3.21875 16C3.21875 23.0416 8.92712 28.75 15.9688 28.75C23.0104 28.75 28.7188 23.0416 28.7188 16C28.7188 8.95837 23.0104 3.25 15.9688 3.25ZM16.7188 12C16.7188 11.5858 16.383 11.25 15.9688 11.25C15.5545 11.25 15.2188 11.5858 15.2188 12V17C15.2188 17.4142 15.5545 17.75 15.9688 17.75C16.383 17.75 16.7188 17.4142 16.7188 17V12ZM15.9688 20.25C15.5545 20.25 15.2188 20.5858 15.2188 21V21.01C15.2188 21.4242 15.5545 21.76 15.9688 21.76H15.9787C16.393 21.76 16.7287 21.4242 16.7287 21.01V21C16.7287 20.5858 16.393 20.25 15.9787 20.25H15.9688Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleLight);
export default __webpack_public_path__ + "static/media/exclamation-circle-light.53c948903c26f53269d198cc73d88ae4.svg";
export { ForwardRef as ReactComponent };